import React from 'react';
import './CustomFormComponents.css';

// Custom TextField Component
const CustomTextField = ({ 
    label, 
    value, 
    onChange, 
    placeholder, 
    required = false, 
    multiline = false, 
    rows = 1, 
    fullWidth = false, 
    margin = "none", 
    type = "text",
    helperText = "",
    sx = {},
    variant = "outlined",
    inputProps = {}
}) => {
    const inputId = `custom-textfield-${Math.random().toString(36).substr(2, 9)}`;
    
    return (
        <div 
            className={`custom-textfield ${fullWidth ? 'custom-textfield-fullwidth' : ''} ${margin === 'normal' ? 'custom-textfield-margin-normal' : ''}`}
            style={sx}
        >
            {label && (
                <label className="custom-textfield-label" htmlFor={inputId}>
                    {label}
                    {required && <span className="custom-textfield-required">*</span>}
                </label>
            )}
            {multiline ? (
                <textarea
                    id={inputId}
                    className="custom-textfield-input custom-textfield-textarea"
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    rows={rows}
                    {...inputProps}
                />
            ) : (
                <input
                    id={inputId}
                    className="custom-textfield-input"
                    type={type}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    {...inputProps}
                />
            )}
            {helperText && <div className="custom-textfield-helper">{helperText}</div>}
        </div>
    );
};

// Custom Button Component
const CustomButton = ({ 
    children, 
    onClick, 
    variant = "text", 
    color = "primary", 
    size = "medium", 
    startIcon = null, 
    disabled = false,
    type = "button",
    sx = {}
}) => {
    const buttonClass = `custom-button custom-button-${variant} custom-button-${color} custom-button-${size}`;
    
    return (
        <button
            className={buttonClass}
            onClick={onClick}
            disabled={disabled}
            type={type}
            style={sx}
        >
            {startIcon && <span className="custom-button-start-icon">{startIcon}</span>}
            {children}
        </button>
    );
};

// Custom Alert Component
const CustomAlert = ({ severity = "info", children, sx = {} }) => {
    return (
        <div className={`custom-alert custom-alert-${severity}`} style={sx}>
            <div className="custom-alert-icon">
                {severity === 'error' && '⚠️'}
                {severity === 'success' && '✅'}
                {severity === 'info' && 'ℹ️'}
                {severity === 'warning' && '⚠️'}
            </div>
            <div className="custom-alert-message">
                {children}
            </div>
        </div>
    );
};

// Custom Box Component
const CustomBox = ({ children, sx = {}, display, justifyContent, alignItems, gap, mb, mt, flexDirection, ...props }) => {
    const style = {
        ...sx,
        display: display || sx.display,
        justifyContent: justifyContent || sx.justifyContent,
        alignItems: alignItems || sx.alignItems,
        gap: gap ? `${gap * 8}px` : sx.gap,
        marginBottom: mb ? `${mb * 8}px` : sx.marginBottom,
        marginTop: mt ? `${mt * 8}px` : sx.marginTop,
        flexDirection: flexDirection || sx.flexDirection,
    };
    
    return (
        <div style={style} {...props}>
            {children}
        </div>
    );
};

export { CustomTextField, CustomButton, CustomAlert, CustomBox };